/**
 * Date: 2020-12-22 15:10:31
 * description:
 *  @author zhizhan
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */
const totalRule = (value, rule) => {};
const arrayRule = (value, rule) => {};
const componentSelect = () => {};
const filterControl = () => {};
/**
 * description: 计算对象值
 * return {*}
 * param {obj} value
 */
const objRule = (value, v) => {};
export { totalRule, arrayRule, objRule, componentSelect, filterControl };



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxIncrementForm/tools.js